import ENV from "../env";

async function duplicateTicketingEvent({ eventId, orgId }) {
  const response = await fetch(`${ENV.firebaseApiUrl}/ticketing/duplicate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ eventId, orgId }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data?.error || "Ticketing duplication failed");
  }

  return data;
}

export default duplicateTicketingEvent;
